import { useEffect, useState } from "react";
import { getMongoTaskData } from "../../../services/mongo/auto4client";

/**
 * Custom hook to fetch and manage MongoDB task data
 * @returns {Object} MongoDB task data state and related functions
 */
function useMongoTaskData() {
  const [taskData, setTaskData] = useState([]);

  const fetchTaskData = async () => {
    const mongoTaskDataRes = await getMongoTaskData();
    const mongoTaskDataJson = await mongoTaskDataRes.json();

    // Update task data with stringified task IDs
    const updatedTaskData = mongoTaskDataJson.task_data.map((element) => ({
      ...element,
      "task-id": element["task-id"].toString(),
    }));

    setTaskData(updatedTaskData);
  };

  useEffect(() => {
    fetchTaskData();
  }, []);

  return {
    taskData,
    fetchTaskData,
  };
}
export default useMongoTaskData;
